import enums from "./enums";

export default [
    {
        name: 'Dashboard',
        path: enums.RoutePathEnum.LOGIN_DASHBOARD,
        iconName: 'grid-icon'
    },
    {
        name: 'Account unification',
        path: enums.RoutePathEnum.ACCOUNT_UNIFICATION,
        iconName: 'user-check-icon',
        scope: enums.ScopesEnum.MANAGE_USERS
    },
];